<template>
  <div
    ref="container"
    class="scrollbar-none flex flex-nowrap gap-8 overflow-x-auto"
    :class="maskClass"
  >
    <RevButtonBase
      v-for="(link, index) in links"
      :key="link.relativeLink"
      class="bg-action-default-mid hover:bg-action-default-mid-hover text-action-default-hi body-2 flex h-36 w-fit shrink-0 items-center rounded-full px-12"
      :to="link.relativeLink"
      @click="trackFacetLinkClick(link, index)"
    >
      {{ link.title }}
    </RevButtonBase>
  </div>
</template>

<script lang="ts" setup>
import { nextTick, useTemplateRef, watch } from 'vue'

import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { RevButtonBase } from '@ds/components/ButtonBase'

import type { LinkBooster } from '~/api/internal-links/types'

import { useScrollMaskClass } from '../../composables/useScrollMaskClass'

const props = defineProps<{
  links: LinkBooster[]
}>()

const { trackClick } = useTracking()

const container = useTemplateRef<HTMLDivElement>('container')
const { maskClass, onScrollAreaChange } = useScrollMaskClass(container)

function trackFacetLinkClick(link: LinkBooster, index: number) {
  trackClick({
    zone: 'filter',
    name: 'Quick Filters',
    value: link.title,
    position: index + 1,
  })
}

watch(
  () => props.links,
  () => nextTick(onScrollAreaChange),
)
</script>
